import React, { useEffect } from "react";
import { useDatatableWrapper } from "react-bs-datatable";

/**
 * ScrollLazyLoader progressively increases the rowsPerPage state when the user 
 * scrolls near the bottom of the page, acting as an infinite scroll within 
 * react-bs-datatable.
 */
const ScrollLazyLoader = ({ maxRows = 1000, step = 50 }) => {
  const { rowsPerPageState, onRowsPerPageChange, filteredDataLength } =
    useDatatableWrapper();

  useEffect(() => {
    const handleScroll = () => {
      // Check if we are near the bottom of the page
      const scrollTop = window.scrollY || document.documentElement.scrollTop;
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;

      if (scrollTop + windowHeight >= documentHeight - 300) {
        if (
          rowsPerPageState < maxRows &&
          rowsPerPageState < filteredDataLength
        ) {
          const nextRows = Math.min(
            rowsPerPageState + step,
            maxRows,
            filteredDataLength
          );
          if (nextRows !== rowsPerPageState) {
            onRowsPerPageChange(nextRows);
          }
        }
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [rowsPerPageState, onRowsPerPageChange, filteredDataLength, maxRows, step]);

  return null;
};

export default ScrollLazyLoader;
